import React from "react";
import { observer } from "mobx-react-lite";
import styled from "styled-components";
import { CharacterSelectionHelper } from "../../helper/CharacterSelectionHelper";
import { translationStore } from "../../stores/TranslationStore";
import { gameStore } from "../../stores/GameStore";
const Container = styled.div.withConfig({
  displayName: "SkinClassIcon__Container",
  componentId: "sc-1211pjv-0"
})(["width:100%;align-items:center;justify-content:center;text-align:center;"]);
const IconContainer = styled.div.withConfig({
  displayName: "SkinClassIcon__IconContainer",
  componentId: "sc-1211pjv-1"
})(["font-size:xx-large;"]);
export const SkinClassIcon = observer(({
  className
}) => {
  const icon = CharacterSelectionHelper.ClassNameToIcon.get(className);
  return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(IconContainer, null, icon), !icon && /*#__PURE__*/React.createElement("span", null, translationStore.makeshiftTranslationSystemData.characterSkinVariantClasses.getTranslation(gameStore.languageKey, className)));
});